import { useEffect, useRef, useState } from "react";
import { IoCamera } from "react-icons/io5";
import ClipLoader from "react-spinners/ClipLoader";
import {
  Button,
  Description,
  SubTitle,
} from "../../Components/CustomComponents";
import TextEditor from "../../Components/TextEditor/TextEditor";
import { useUpdateProfileMutation } from "../../Data/services/settingApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import styles from "./styles/EditProfile.module.scss";
import ColorThemeSelector from "./ThemeSelector";
import { Col, Row } from "react-bootstrap";
import Fieldset from "../../Components/FieldSet";
import EmailTemplateSkeleton from "../../Components/Skeleton/EmailTemplateSkeleton";

export default function EmailTemplate() {
  const fileInputRef = useRef(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState("");

  const [value, setValue] = useState(
    "Hi [User’s First Name],We value your trust and privacy. As part of our commitment to transparency, we have updated our Privacy Policy.What’s New?Clearer explanation of how we use your data. Better details on cookies and tracking. Your rights regarding your personal information. You can read the full Privacy Policy here: [Insert Privacy Policy Link] If you have any questions, feel free to reach us at support@example.com. Thank you for being part of [Your Company Name]. Best regards, [Your Company Name] Team"
  );

  const [activeTheme, setActiveTheme] = useState("Default");

  const [dummyFetch, setDummyFetch] = useState({
    isLoading: true,
    isFetching: true,
  });

  useEffect(() => {
    setTimeout(() => {
      setDummyFetch((prev) => {
        return {
          ...prev,
          isLoading: false,
          isFetching: false,
        };
      });
    }, 2000);
  }, []);

  const handleThemeChange = (themeName) => {
    console.log("Parent received theme:", themeName);
    setActiveTheme(themeName);
  };

  // const {
  //   data: profileData,
  //   isLoading,
  //   refetch,
  // } = useGetProfileQuery({
  //   refetchOnMountOrArgChange: true,
  // });

  // useEffect(() => {
  //   if (profileData && profileData.data) {
  //     const { firstname, lastname, email, image_url, name } = profileData.data;
  //     setFirstName(firstname || "");
  //     setLastName(lastname || "");
  //     setEmail(email || "");
  //     setName(name || "");
  //     setImagePreview(image_url || null); // Set the image preview if available
  //   }
  // }, [profileData]);

  const handleValueChange = (newText) => {
    setValue(newText);
    // console.log("Updated text:", newText);
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file)); // Create a preview URL
    }
  };

  const [updateProfile, { isLoading: isUpdating }] = useUpdateProfileMutation();

  const handleSubmit = async () => {
    // Handle form submission
    const formData = new FormData();
    formData.append("image_url", imageFile);
    formData.append("email_template", value);
    formData.append("theme", activeTheme);

    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    return;

    try {
      const response = await updateProfile(formData);
      console.log(response);

      if (response?.data?.code === 200) {
        // refetch();
        SuccessToast(response?.data?.message);
      }
    } catch (error) {
      console.error("Failed to update profile:", error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  return (
    <div className={styles.EditProfile}>
      <SubTitle text="App Settings" />
      <Description
        text="You can edit your app logo here and create email template."
        classes="fs-8 mb-4"
      />
      {dummyFetch.isFetching ? (
        <EmailTemplateSkeleton />
      ) : (
        <div className={`${styles.form} mw-100`}>
          <Row>
            <Col xs={12} sm={3}>
              <Fieldset legend={"App Logo"} className="h-100">
                <div className="d-flex flex-column gap-3  w-100 align-items-center">
                  <div className={styles.userImageContainer}>
                    <img
                      src={imagePreview || "/images/no_image_available.png"}
                      alt="User Profile"
                      className={styles.userImage}
                    />
                    <span
                      className={styles.cameraIcon}
                      onClick={handleUploadClick}
                    >
                      <IoCamera color="white" />
                    </span>
                    {/* Hidden file input */}
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                      accept="image/*" // Limit to image files
                    />
                  </div>
                </div>
              </Fieldset>
            </Col>
            <Col xs={12} sm={9}>
              <Fieldset legend="Notification Email Template">
                <TextEditor text={value} onChange={handleValueChange} />
              </Fieldset>
            </Col>
          </Row>

          <br />

          <ColorThemeSelector onThemeChange={handleThemeChange} />
          <br />

          <Button
            text={
              isUpdating ? <ClipLoader color="#0f0f0f" size="22px" /> : "Save"
            }
            classes={`fs-6 mb-2 mt-auto mt-3 mb-2 ${
              isUpdating ? "bg-dark-subtle" : ""
            }`}
            disabled={isUpdating}
            onClick={handleSubmit}
          />
        </div>
      )}
    </div>
  );
}
